module.exports = __webpack_public_path__ + "img/9.6d2f8eb7.png";